export enum ApiEndPoint {
  Auth,
  Payment,
  Notifications,
  Support,
  Assessments
}
